// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-6be370fe] {\n  width: 100%;\n}\n.content .panel[data-v-6be370fe] {\n  display: flex;\n  justify-content: center;\n}\n.content .btn[data-v-6be370fe] {\n  width: 180px;\n  height: 40px;\n  background: #1258bc;\n  border-radius: 4px 4px 4px 4px;\n  opacity: 1;\n  font-size: 14px;\n  font-family: Microsoft YaHei-Regular, Microsoft YaHei;\n  font-weight: 400;\n  color: #ffffff;\n  line-height: 40px;\n  text-align: center;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
